import React from 'react';
import { FEATURE_FLAG__BEGIN_15 } from '../../../../constants/featureflags';
import { EXPERIMENT_PAGE_DESIGN_FLAGS } from '../../../../experiments/constants';
import { useExperimentOrFeatureFlagData } from '../../../../experiments/hooks';
import { useCodeSparkFlag } from '../../../../featureFlags';
import { getHeroVariantData } from './heroData';

const experimentVariants = [FEATURE_FLAG__BEGIN_15, 'quizHero', ...EXPERIMENT_PAGE_DESIGN_FLAGS];
function Hero({ onCtaClick }) {
  const { component: Component, data, ctaId } = useExperimentOrFeatureFlagData(
    experimentVariants,
    getHeroVariantData
  );

  const handleCtaClick = (e, extraParams) => onCtaClick(e, ctaId, extraParams);

  return <Component onCtaClick={handleCtaClick} data={data} />;
}

export default Hero;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Hero/index.js